'use client'
import Link from 'next/link'
import AnimatedSection from '@/components/AnimatedSection'
import styles from './not-found.module.css'

export default function NotFound() {
  return (
    <div className={styles.page}>
      <AnimatedSection animation="fadeIn">
        <main className={styles.root}>
          <h1 className={styles.title}>404</h1>
          <h3 className={styles.subtitle}>Страница не найдена</h3>
          <p className={styles.text}>К сожалению, нам не удалось найти страницу по вашему запросу. Вы можете вернуться на главную.</p>
          <Link className={styles.button} href="/">
            <span className={styles.buttonText}>На главную</span>
            <svg className={styles.buttonIcon} viewBox="0 0 16 16" fill="none">
              <path d="M6.33333 3V4.33333H10.7267L3 12.06L3.94 13L11.6667 5.27333V9.66667H13V3H6.33333Z" fill="white" />
            </svg>
          </Link>
        </main>
      </AnimatedSection>
    </div>
  )
}